
import React from 'react';

import IntroImage from '../images/192721015_ebb5e9a9-c897-4996-a1e1-5219ede67436.jpg';
import CheckImg from '../images/checked_339818.svg';
import IconCard1 from '../images/star_8622334.svg';
import IconCard2 from '../images/number-5_13318298.svg';
import IconCard3 from '../images/internet_7989406.svg';
import IconCard4 from '../images/list_265182.svg';

export default function JuryPolicy() {
  const qualifications = [
    {
      icon: IconCard1,
      title: 'Blind-оценка заявок',
      desc: 'Каждый кейс оценивается без указания имени участника, бренда или страны происхождения'
    },
    {
      icon: IconCard2,
      title: 'Экспертная оценка по пяти критериям',
      desc: 'Стратегическая обоснованность, реализация, результативность, инновационность, устойчивость. Каждая категория оценивается по 10-балльной шкале с верифицированными пояснениями'
    },
    {
      icon: IconCard3,
      title: 'Финальная онлайн-дискуссия',
      desc: 'Где осуществляется обсуждение шорт-листа, выносится коллегиальное решение и проводится тайное голосование за победителя в каждой номинации'
    },
    {
      icon: IconCard4,
      title: 'Оформление результатов оценки',
      desc: 'В протоколах, подписываемых всеми участвующими экспертами.'
    },
  ];


  return (
    <article className="jury-policy">
      <section className="section jury-policy__intro">
        <h1 className="section-title">ЖЮРИ INTERNATIONAL CMO SUMMIT AWARDS</h1>
        <p className="jury-policy__subtitle">
          Формирование, состав, принципы работы и юридическая подотчётность
        </p>
          <div className="jury-policy__intro-image">
          <img src={IntroImage} alt="Жюри International CMO Summit Awards" />
        </div>
      </section>

      <section className="sectin-jury jury-policy__section">
        <h2 className="section-title">1. Общие положения</h2>
        <p>
          Жюри Международной Премии International Chief Marketing Officer Summit Awards (далее — «Жюри») является постоянно действующим коллегиальным органом, сформированным Украинской Ассоциацией Маркетинга (УАМ) — учредителем Премии, с целью обеспечения объективной, независимой и профессионально верифицированной оценки конкурсных заявок. Жюри действует на основании настоящего Положения, утверждённого Оргкомитетом УАМ.
        </p>
        <p>Все члены жюри официально утверждаются Организатором и обязаны подписать юридически обязывающие документы, включая:</p>
        <ul className="jury-policy__list">
          <li><img src={CheckImg} alt="" /> Соглашение о конфиденциальности (NDA)</li>
          <li><img src={CheckImg} alt="" /> Декларацию об отсутствии конфликта интересов</li>
          <li><img src={CheckImg} alt="" /> Кодекс профессиональной этики и независимости</li>
        </ul>
      </section>

      
      <section className="sectin-jury jury-policy__section">
        <h2 className="section-title">2. Квалификационные требования</h2>
        <p>
          Кандидаты в состав жюри должны соответствовать всем нижеперечисленным критериям:
        </p>
        <ul className="jury-policy__list">
          <li><img src={CheckImg} alt="" /> 2.1. Минимум 5 лет опыта на руководящей должности в области маркетинга, стратегических коммуникаций, digital, брендинга или исследований на уровне C-level в международных компаниях, агентствах или академических учреждениях;</li>
          <li><img src={CheckImg} alt="" /> 2.2. Подтверждённая международная профессиональная репутация, подтверждаемая реализованными проектами, публикациями, академическими званиями или участием в глобальных отраслевых форумах (Web Summit, Cannes Lions, WARC, Effie Awards, Global Marketing Day, Festival of Media Global и др.);</li>
          <li><img src={CheckImg} alt="" /> 2.3. Активное членство хотя бы в одной международной профессиональной ассоциации (ESOMAR, IAA, AMA, The Marketing Society, CMO Council и др.);</li>
          <li><img src={CheckImg} alt="" /> 2.4. Способность оценивать заявки по утверждённым критериям вне зависимости от страны происхождения проекта, рыночного масштаба или языка реализации;</li>
          <li><img src={CheckImg} alt="" /> 2.5. Отсутствие аффилированности с заявителями и любых прямых коммерческих интересов, способных повлиять на независимость оценки.</li>
        </ul>
      </section>

              <section className="sectin-jury jury-policy__section">
        <h2 className="section-title">3. Процедура отбора и утверждения членов жюри</h2>
        <p>Все кандидаты на участие в составе Жюри проходят формализованную процедуру рассмотрения, включающую:</p>
        <ul className="jury__list">
          <li> Предварительный отбор на основании предоставленного резюме, портфолио и списка реализованных кейсов;</li>
          <li> Проверку поданных сведений Организационным комитетом и службой комплаенса УАМ на соответствие критериям этики, независимости и профессиональной репутации;</li>
          <li> Утверждение кандидатуры и подписание юридических документов.</li>
        </ul>
        <p>Жюри формируется ежегодно. Утверждённый список членов жюри публикуется на официальном сайте Премии по завершении конкурсного цикла и доступен для верификации.</p>
      </section>

      <section className="sectin-jury jury-policy__section">
        <h2 className="section-title">4. Обязанности и принципы работы жюри</h2>
                <p>
          Члены жюри могут по желанию участвовать в открытых сессиях, публичных панелях и церемониях награждения, выступая в роли спикеров и экспертов.
        </p>
                <p>
          Члены жюри принимают участие в следующих этапах оценки:
        </p>
        <div className="jury-policy__cards">
          {qualifications.map(q => (
            <div key={q.title} className="card jury-policy__card">
              <div className="jury-policy__card-icon">
                <img src={q.icon} alt="" />
              </div>
              <h3 className="jury-policy__card-title">{q.title}</h3>
              <p className="jury-policy__card-text">{q.desc}</p>
            </div>
          ))}
        </div>
      </section>

              <section className="sectin-jury jury-policy__section">
        <h2 className="section-title">5. Независимость и подотчётность</h2>
        <p>Каждый член жюри подписывает декларацию о своей неаффилированности и обязуется:</p>
        <ul className="jury__list">
          <li>Не допускать предвзятости или зависимости при оценке;</li>
          <li>Не использовать внутреннюю информацию о заявках в личных или коммерческих целях;</li>
          <li>Сообщать о любом потенциальном конфликте интересов до начала оценки.</li>
        </ul>
        <p>Нарушение данных принципов влечёт за собой немедленное отстранение и аннулирование полномочий.</p>
      </section>

              <section className="sectin-jury jury-policy__section">
        <h2 className="section-title">6. Правовая подотчётность</h2>
        <p>Жюри является органом, учреждённым в рамках процедуры Премии и действует в соответствии с Положением о Премии, утверждённым Украинской Ассоциацией Маркетинга. Все решения жюри документируются, хранятся в протоколах, и подлежат последующей верификации.</p>
        <p>Жалобы и апелляции по вопросам, связанным с деятельностью жюри, рассматриваются независимым Этическим комитетом УАМ в срок до 30 календарных дней с момента подачи соответствующего заявления.</p>
      </section>

    </article>
);
}
